import { Reducer } from 'redux'
import * as actions from './actions'
import { User } from './types'

export type UserState = Readonly<{
  token: string | null
  role: string | null
  user: User
}>

export const initState: UserState = {
  token: null,
  role: null,
  user: {
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    userType: ''
  }
}

export const userReducer: Reducer<UserState> = (state = initState, action) => {
  switch (action.type) {
    case actions.SET_TOKEN:
      return {
        ...state,
        token: action.payload.token,
        role: action.payload.role
      }
    default:
      return state
  }
}
